import * as React from 'react'

import { Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

interface DateProps {
  isDefaultAssignment: boolean
  isLastAssignment: boolean
  start_at: string
  end_at: string
}

export const DateField = ({
  isDefaultAssignment,
  isLastAssignment,
  start_at,
  end_at,
}: DateProps) => {
  const defaultFormat = 'ui_dmy_long'

  const rangeLabel = (): string => {
    const start_at_date = moment(start_at)
    const end_at_date = moment(end_at)
    const startEndSameYear = start_at_date.isSame(end_at_date, 'year')

    return i18n.t('time_off.cycle', {
      begin: dateToString(moment(start_at), startEndSameYear ? 'ui_dm_long' : defaultFormat), // If start and end are in the same year, we don't need to show the year
      end: dateToString(moment(end_at), defaultFormat),
    })
  }

  if (isLastAssignment) {
    return (
      <Text size="200" weight="medium">
        {i18n.t('common.from_date', { date: dateToString(moment(start_at), defaultFormat) })}
      </Text>
    )
  }

  if (isDefaultAssignment) {
    return (
      <Text size="200" weight="medium">
        {dateToString(moment(start_at), defaultFormat)}
      </Text>
    )
  }

  return (
    <Text size="200" weight="medium">
      {rangeLabel()}
    </Text>
  )
}
